<template>
  <div id="app" v-bind:class="`in-iframe-${inIframe}`">
    <top-bar></top-bar>
    <div class="router-container">
      <wrap-container class="w100 router-container-inner">
        <wrap-container class="w50-fixed">
          <transition name="route-transition">
            <router-view class="container" />
          </transition>
          <transition name="route-transition">
            <router-view class="container" name="tipoConsulta" />
          </transition>
          <transition name="route-transition">
            <router-view class="container" name="subSegment" />
          </transition>
          <transition name="route-transition">
            <router-view v-if="!noResolvimos" class="container" name="help" />
          </transition>
          <transition name="route-transition">
            <wrap-container v-if="noResolvimos">
              <formulario-contacto />
            </wrap-container>
          </transition>
        </wrap-container>
      </wrap-container>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import AppFooter from "@/components/core/AppFooter";
import WrapContainer from "@/components/core/Container";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";
import TopBar from "@/components/core/TopBar";

export default {
  name: "App",
  components: {
    TopBar,
    AppFooter,
    FormularioContacto,
    WrapContainer
  },
  data() {
    return {
      inIframe: window.top !== window.self
    };
  },
  computed: {
    noResolvimos() {
      return !!this.$route.params.noResolvimos;
    }
  }
};
</script>

<style>
@import "./style/base.css";
@import "./style/media.css";
@import "./style/grid.css";

#app {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: auto;
}

.router-container {
  padding-top: 90px;
  padding-left: 17px;
  padding-right: 17px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

div.router-container div.router-container-inner {
  padding-bottom: 40px;
  /** Altura mínima para evitar "saltos" al cambiar el router */
  min-height: 800px;
}

.in-iframe-true .router-container {
  padding-top: 0 !important;
}

.route-transition-enter-active,
.route-transition-leave-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s;
}
.route-transition-enter,
.route-transition-leave-to {
  transition: none;
  opacity: 0;
  transform: translateY(-40px);
}

@media screen and (min-width: 600px) {
  .router-container {
    /*El padding debe incluir la top bar + padding de contenedor y dar una distancia de 60 px
    entre el topbar y el primer título
    padding = altura top bar - 17px + 60px;
    */
    padding-top: 120px;
  }
}
</style>
